export abstract class DateService {
  abstract now(): string;
  abstract today(): string;
  abstract weekStart(date: string): string;
}
